import { render, staticRenderFns } from "./PresentationConfiguration.vue?vue&type=template&id=4978a95b&scoped=true&"
import script from "./PresentationConfiguration.vue?vue&type=script&lang=ts&"
export * from "./PresentationConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978a95b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4978a95b')) {
      api.createRecord('4978a95b', component.options)
    } else {
      api.reload('4978a95b', component.options)
    }
    module.hot.accept("./PresentationConfiguration.vue?vue&type=template&id=4978a95b&scoped=true&", function () {
      api.rerender('4978a95b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/PresentationConfiguration.vue"
export default component.exports